import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessAccountRequestComponent } from './business-account-request.component';
import { BusinessAccountRequestService } from './business-account-request.service';
import { CommonErrorModule } from '../common-error';
import { KngDialogTooltipModule, KngLoaderModule, KngTableModule, KngUploadFileModule, ModalModule } from 'kinetic-angular';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { BusinessAccountRequestUtilService } from './business-account-request-util.service';


@NgModule({
	declarations: [
		BusinessAccountRequestComponent
	],
	imports: [ CommonModule, KngTableModule, KngDialogTooltipModule, KngLoaderModule, CommonErrorModule, ReactiveFormsModule, ModalModule, MatSelectModule, FormsModule, KngUploadFileModule,
		ToastrModule.forRoot({
			preventDuplicates: true,
			closeButton: true
		}) ],
	exports: [
		BusinessAccountRequestComponent
	],
	providers: [
		BusinessAccountRequestService, BusinessAccountRequestUtilService
	]
})
export class BusinessAccountRequestModule {}
